import React from "react";
import { useState, useRef, useEffect } from "react";
import { Row, Col, Image } from "react-bootstrap";
import { ExcelNameExport } from "../../../components";
import { ssnMasking } from "../../../utils";
import { useDeepEffect, useRequest } from "../../../abstracts";
import { dataOverrideReport } from "./constant";
import {
  getDataOverrideInformationById,
  getDownloadDataOverrideReport,
} from "../../../services";
import ExcelImage from "../../../styles/file-spreadsheet.png";
import * as fileSaver from "file-saver";
import { isEmpty } from "lodash-es";
import InfiniteScroll from "react-infinite-scroller";
// import axios from "axios";
// import { apiDetails } from "../../../services/helpers";

const DataOverride = ({ data, payrollId }) => {
  const [dataOverride, setDataOverride] = useState([]);

  const [element, setElement] = useState(null);
  const [start, setStart] = useState(1);
  const [isScroll, setIsScroll] = useState(true);
  const [apiData, setApiData] = useState([]);
  const [stopInfiniteScroll, setStopInfiniteScroll] = useState(false);
  const [append, setAppend] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [request, setRequest] = useState({
    fileId: payrollId,
    pageNumber: 1,
  });

  const exportReportFile = (data) => {
    getDownloadDataOverrideReport(payrollId)
      .then((response) => {
        var blob = new Blob([response], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fileSaver.saveAs(blob, "DataOverride.xlsx");
      })
      .catch((error) => {});
  };

  // function exportReportFile() {
  //   axios.get(apiDetails.baseUrl.trim() + '/api/v1/Report/DownloadDataOverrideReport/1', { responseType: 'arraybuffer' })
  //     .then((response) => {
  //       var blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  //       fileSaver.saveAs(blob, 'DataOverride.xlsx');
  //     });
  // }

  useDeepEffect(() => {
    setIsLoading(true);
    getDataOverrideInformationById(request)
      .then((response) => {
        setCount(response.count);
        if (response?.dataOverrideReportDetails?.length < 5)
          setStopInfiniteScroll(true);
        if (append) {
          setCount(response.count);
          setDataOverride((dataOverride) => {
            return [...dataOverride, ...response?.dataOverrideReportDetails];
          });
        } else setDataOverride(response?.dataOverrideReportDetails);
        setCount(response.count);
        setIsLoading(false);
      })
      .catch((error) => {
        //Handle Errors
        setIsLoading(false);
      });
  }, [request]);

  return (
    <div className="parentclass">
      <div className="d-flex justify-content-between align-center">
        <div className="ft-12 grey-text font-weight-500">
          Data Override in {count} Records
        </div>
        <div className="change-data">
          {/* <ExcelNameExport
            headers={dataOverrideReport}
            data={dataOverride}
            fileName={"data_override.xls"}
            name="Data Override Report"
          /> */}
          <p className="excel-text" onClick={() => exportReportFile()}>
            <span>Data Override Report</span>
          </p>
          <p onClick={() => exportReportFile()}>
            <div className="image-excel">
              <Image src={ExcelImage} width="14px" />
            </div>
          </p>
        </div>
      </div>
      <div className="payroll_scroll">
        <InfiniteScroll
          pageStart={0}
          loadMore={() => {
            setAppend(true);
            setRequest((request) => {
              return { ...request, pageNumber: request.pageNumber + 1 };
            });
          }}
          hasMore={!stopInfiniteScroll}
          initialLoad={false}
          threshold={100}
          useWindow={false}
          loader={
            <div className="loader" key={0}>
              Loading ...
            </div>
          }
        >
          {dataOverride?.map((dataOverride) => (
            <div ref={setElement} className="data-change">
              <Row>
                <Col md="3">
                  <p className="ft-14 font-weight-500">
                    {dataOverride.employeeSSN}
                  </p>
                  <p className="ft-14 font-weight-500 overflow-wrap">
                    {dataOverride.name}
                  </p>
                </Col>
                <Col>
                  {dataOverride.dataOverrideDetails.map((item, index) => (
                    <div>
                      <Row>
                        <Col md="3">
                          <p className="ft-12 grey-text font-weight-500">
                            Data Override
                          </p>
                          <p className="ft-14 font-weight-500 overflow-wrap">
                            {item.fieldName}
                          </p>
                        </Col>

                        <Col md="4">
                          <p className="ft-12 grey-text font-weight-500">
                            Original Data
                          </p>
                          <p className="ft-14 font-weight-500 overflow-wrap">
                            {item.original}
                          </p>
                        </Col>

                        <Col md="4">
                          <p className="ft-12 grey-text font-weight-500">
                            Submitted Data
                          </p>
                          <p className="ft-14 font-weight-500 overflow-wrap">
                            {item.changedTo}
                          </p>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </Col>
              </Row>
            </div>
          ))}
        </InfiniteScroll>
      </div>
    </div>
  );
};

export default DataOverride;
